import { makeObservable, observable, action, IObservableFactory, IActionFactory, IComputedFactory } from "mobx";
import { BaseUserStore } from "./baseStores/BaseUserStore";

export const createObservableFromBaseUser = <TClass extends BaseUserStore>(
  context: TClass,
  additionalFields: Record<
    Exclude<keyof TClass, keyof BaseUserStore>,
    IObservableFactory | IActionFactory | IComputedFactory
  >
): void => {
  makeObservable<BaseUserStore & TClass>(context, {
    users: observable,
    usersProfiles: observable,
    usersProfilesAdmins: observable,
    usersProfilesParents: observable,
    usersProfilesStudents: observable,
    usersProfilesSupervisors: observable,
    usersProfilesTutors: observable,
    getUser: action,
    getUsers: action,
    createProfile: action,
    createUser: action,
    deleteProfile: action,
    deleteUser: action,
    restoreProfile: action,
    updateProfile: action,
    updateUser: action,
    ...additionalFields,
  });
};
